import { classNames } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { Button } from './Button';
import { Closeable } from 'components/util/Closeable';
import { React } from 'libs/react';
import './ButtonDropdown.scss';
/**
 * @component ButtonDropdown
 * @since 1.0.0
 * @hidden
 */
export function ButtonDropdown(props) {
    const { style, options, picto } = Object.assign({ style: 'normal', picto: 'ellipsis' }, props);
    const [active, setActive] = useState(false);
    /**
     * @function onClick
     * @since 1.0.0
     * @hidden
     */
    function onClick() {
        setActive((active) => !active);
    }
    /**
     * @function onClose
     * @since 1.0.0
     * @hidden
     */
    function onClose() {
        setActive(false);
    }
    /**
     * @function onSelect
     * @since 1.0.0
     * @hidden
     */
    function onSelect(value) {
        requestAnimationFrame(() => {
            if (props.onSelect) {
                props.onSelect(value);
            }
        });
        setActive(false);
    }
    useIf(active, props.onOpen, props.onClose);
    const className = classNames('button-dropdown', 'button-dropdown--' + style, { 'button-dropdown--is-active': active }, props.className);
    return (React.createElement(Closeable, { onClose: onClose },
        React.createElement("div", { className: className },
            React.createElement("div", { className: "button-dropdown-main" },
                React.createElement(Button, { style: "picto", picto: picto, onPress: onClick })),
            React.createElement("div", { className: "button-dropdown-menu" },
                React.createElement("div", { className: "button-dropdown-menu-items" }, options.map((option) => (React.createElement(Button, { key: option.value, picto: option.picto, label: option.label, onPress: () => onSelect(option.value) }))))))));
}
